// src/components/pages/backtest/partials/BenchmarkSection.js

import React from 'react';
import { NumericFormat } from "react-number-format";
import TickerRow from '../../../TickerRow/TickerRow';
import styles from '../style/BacktestPage.module.css';

// SVG Helper 함수 (재정의 또는 공통 유틸로 분리 가능)
const getRemoveButtonSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
);

const BenchmarkSection = ({ setup, actions, runner, auth, t }) => {
    return (
        <div className={styles.inputContainer}>
            <h2>{t("backtest.benchmark")}</h2>
            {/* 입력 모드 선택 토글 */}
            <div className={styles.toggleGroup}>
                <button
                    className={`${styles.toggleButton} ${setup.benchmarkInputMode === 'ticker' ? styles.active : ''}`}
                    onClick={() => setup.setBenchmarkInputMode('ticker')}
                >
                    {t("backtest.singleTicker")}
                </button>
                <button
                    className={`${styles.toggleButton} ${setup.benchmarkInputMode === 'portfolio' ? styles.active : ''}`}
                    onClick={() => setup.setBenchmarkInputMode('portfolio')}
                >
                    {t("backtest.portfolio")}
                </button>
            </div> 

            <div >
                {/* 단일 티커 입력 모드 */}
                {setup.benchmarkInputMode === 'ticker' && (
                    <TickerRow value={setup.benchmark} onChange={setup.setBenchmark} placeholder={"ex) SPY.US, QQQ.US"} />
                )}

                {/* 포트폴리오 입력 모드 */}
                {setup.benchmarkInputMode === 'portfolio' && (
                    <>  
                        <div className={styles.inputSection} style={{ marginTop: actions.isBenchmarkLoadModalOpen ? '10px' : '0' }}> 
                            {setup.benchmarkRows.map((row, index) => (
                                <div key={index} className={styles.inputRow}>
                                    <TickerRow value={row.ticker} onChange={(newTicker) => setup.handleBenchmarkChange(index, "ticker", newTicker)} existingTickers={setup.benchmarkRows.map(r => r.ticker)} />
                                    <NumericFormat value={row.weight} onValueChange={(values) => setup.handleBenchmarkChange(index, "weight", values.value)} className={styles.numericInput} thousandSeparator={true} allowNegative={false} decimalScale={2} suffix="%" placeholder={t("backtest.weightPlaceholder")} />
                                    <button onClick={() => setup.handleRemoveBenchmarkRow(index)} className={styles.removeButton} aria-label="Remove Ticker">
                                        {getRemoveButtonSVG()}
                                    </button>
                                </div>
                            ))}
                        </div>
                        
                        {/* 백테스트 종목 추가/ 비중 합 버튼 */}
                        <div className={styles.buttonSection}>
                            <button onClick={setup.handleAddBenchmarkRow} className={styles.addButton} style={{ marginTop: '10px' }}>{t("backtest.addTicker")}</button>
                            <div className={`${styles.weightSum} ${runner.getWeightSumColor(setup.benchmarkWeightSum)}`} style={{ marginTop: '10px' }}>
                                {t("backtest.totalWeight")}: {setup.benchmarkWeightSum.toFixed(2)}%
                            </div>
                        </div>

                        {/* 💡 [새로운 벤치마크 초기화 버튼 섹션 추가] */}
                        <div className={styles.buttonSection} style={{ marginTop: '10px' }}>
                            <button onClick={setup.handleResetBenchmark} className={styles.resetButton}>
                                {t("backtest.resetButton") || "벤치마크 포트폴리오 초기화"}
                            </button>
                        </div>

                        {/* 벤치마크 포트폴리오 불러오기 버튼 섹션 */}
                        <div className={styles.buttonSection} style={{ marginTop: '10px' }}>
                            <button
                                onClick={() => actions.fetchUserPortfolios(true)} 
                                className={styles.resetButton} 
                                disabled={actions.isPortfoliosLoading}
                                style={{ 
                                    width: '100%', backgroundColor: actions.isPortfoliosLoading ? '#adb5cd' : (actions.isBenchmarkLoadModalOpen ? '#dc3545' : '#6c757d'), 
                                    color: 'white', opacity: actions.isPortfoliosLoading ? 0.7 : 1 
                                }}
                                title={!auth.isAuthenticated ? t('newPortfolioModal.loginRequiredTooltip') : ''}
                            >
                                {actions.isPortfoliosLoading ? t('backtest.loading') : (actions.isBenchmarkLoadModalOpen ? (t('backtest.close') || "닫기") : (t('backtest.loadMyPortfolioButton') || "벤치마크 포트폴리오 불러오기"))}
                            </button>
                        </div>
                        
                        {/* 벤치마크 포트폴리오 목록 표시 (드롭다운) */}
                        {actions.isBenchmarkLoadModalOpen && actions.userPortfolios.length > 0 && (
                            <div className={styles.portfolioDropdown} style={{ marginTop: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f8f9fa' }}>
                                <h3 style={{ margin: '0 0 10px 0', fontSize: '1em', fontWeight: 'bold' }}>{t('backtest.selectPortfolio') || '벤치마크 포트폴리오를 선택하세요.'}</h3>
                                <ul style={{ listStyle: 'none', padding: 0, maxHeight: '200px', overflowY: 'auto' }}>
                                    {actions.userPortfolios.map(p => {
                                        const isAll = p.portfolioType === 'ALL';
                                        return (
                                        <li key={p.portfolioId} className={styles.portfolioListItem} onClick={() => actions.handleLoadBenchmarkPortfolio(p)} style={{ fontWeight: isAll ? 'bold' : 'normal', backgroundColor: isAll ? '#e9f7ff' : '#f8f9fa', color: isAll ? '#007bff' : '#343a40' }}>
                                            <span style={{ flexGrow: 1, cursor: 'pointer' }}>{p.name}</span>
                                        </li>
                                    )})}
                                </ul>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default BenchmarkSection;